import {ActionType, orderDetailType, PAY_STATUS} from "./types";

const defaultState = {
    tradeTime: '',
    merchantName: '',
    merchantNo: '',
    storeName: '',
    storeNo: '',
    termNo: '',
    cashierNo: '',
    cashierName: '',
    currency: '',
    tradeAmt: 0,
    orgCurrency: '',
    orgTradeAmt: 0,
    exchangeFlag: 0,
    exchangeRate: 0,
    feeAmt: 0,
    canRefundAmt: 0,
    payAmt: 0,
    orderNo: '',
    payOrderNo: '',
    partnerOrderNo: '',
    tradeSummary: '',
    status: PAY_STATUS.UNPAID,
    buyer: '',
    wallet: ''
}


const orderDetail = (state: orderDetailType = defaultState, action: ActionType<any>) => {
    switch (action.type) {
        case 'SET_ORDER_DETAIL':
            return {
                ...state,
                ...action.payload.data
            }
        // case 'REFUND_SUCC':
        //     return {
        //         ...state,
        //         orderNo: action.payload.data.orderNo,
        //         canRefundAmt: state.canRefundAmt - action.payload.data.refundAmt,
        //         status: state.canRefundAmt - action.payload.data.refundAmt > 0 ? 1 : 3
        //     }
        default:
            return state;
    }
}
export default orderDetail